import { TweenMax } from "gsap/all";
import Glide from '@glidejs/glide';
import CustomSelect from "./CustomSelect";

const axios = require('axios').default;

class Productos{
    constructor(){
        this.glideOptions = {
            gap: 0,
            perView: 5,
            hoverpause: true,
            gap: 15,
            focusAt: 'center',
            bound: true,
            startAt:3,
            //bound:true,
            breakpoints:{
                900: {
                    perView: 4,
                    startAt:2,
                },
                768: {
                    perView: 3,
                    startAt:1,
                },
                620: {
                    perView: 2
                },
                340: {
                    perView: 1
                }
            }
        };
        this.glide = new Glide('.productgal', this.glideOptions).mount();

        this.selector = new CustomSelect();
        this.select = document.querySelector("select");
        this.glideContainer = document.querySelector(".productgal .glide__slides");
        this.glideBulletsContainer = document.querySelector(".productgal .glide__bullets");
        this.glideArrowsContainer = document.querySelector(".productgal .glide__arrows");
        this.selectedItem = document.querySelector(".selectedItem");
        
        this.selectedPointer = null;

        this.addEvents();
    }

    addEvents(){
        this.select.addEventListener("change", e => {
            this.loadData(this.select.value)
        });
        this.select.dispatchEvent(new Event("change"));
    }

    loadData(category){
        axios.get(window.produtEndpoint+category)
        .then(resp => {
            if(resp.status != 200 || resp.status != 201){
                this.showData(resp.data);
            }else{
                console.error("ERROR: ",resp);
            }
        })
        /*.catch(err => {
            console.error("ERROR: ",err);
            this.showError("Se produjo un error inesperado. Inténtelo más tarde.");
            this.enableForm();
        });*/
    }

    showData(data){
        this.data = data;
        //rebuild glide
        this.glideContainer.innerHTML = "";
        this.glideBulletsContainer.innerHTML = "";
        var chunks;
        if(data.length > 8){
            chunks = this.chunk(data, 2);
        }else{
            chunks = this.chunk(data, 1);
        }
        
        let chunkIndex = 0;
        let dataIndex = 0;
        chunks.forEach(productoChunk => {
            let slide = this.createFromTag("div", ["glide__slide"], `<div class="row"></div>`);
            this.glideContainer.appendChild(slide);
            //make content for each slide
            productoChunk.forEach(producto => {
                const template = `<a href="#" index="${dataIndex}" class="productgal_item rounded overflow-hidden">
                        <div class="productgal_itemwrap position-relative border border-primary">
                            <img src="${producto.img}" class="img-fluid">
                            <p>${producto.titulo}</p>
                        </div>
                    </a>`;
                slide.querySelector(".row").appendChild(this.createFromTag("div", ["col-12"], template));
                dataIndex++;
            });
            //make bullets
            const bullet = this.createFromTag("button", ["glide__bullet"]);
            bullet.setAttribute("data-glide-dir", "="+chunkIndex);
            this.glideBulletsContainer.appendChild(bullet);
            chunkIndex++;
        });

        //if enoush chunks show navigation
        if(chunks.length <= 2){
            this.glideBulletsContainer.classList.add("invisible");
            this.glideArrowsContainer.classList.add("invisible");
        }else{
            this.glideBulletsContainer.classList.remove("invisible");
            this.glideArrowsContainer.classList.remove("invisible");
        }

        this.glide.destroy();
        this.glideOptions.startAt = chunks.length < 6 ? Math.floor(chunks.length) / 2 : 3;
        this.glide = new Glide('.productgal', this.glideOptions).mount();
        
        //add events
        this.glideContainer.querySelectorAll("a").forEach(element => {
            element.addEventListener("click", event => {
                this.selectItem(event.currentTarget.getAttribute("index"));
                if(this.selectedPointer) this.selectedPointer.classList.remove("productgal_item--selected");
                this.selectedPointer = event.currentTarget;
                this.selectedPointer.classList.add("productgal_item--selected");
                event.preventDefault();
            });
        });
        this.glideContainer.querySelector("a").click();
    }

    selectItem(id){
        TweenMax.set(this.selectedItem, {height: this.selectedItem.offsetHeight});
        TweenMax.to(this.selectedItem, 0.5, {y:20, opacity:0, onComplete: function(){
            const template = `<div class="col-xs-12 col-sm-6 order-sm-2">
                <div class="px-base px-sm-half px-md-0"><img src="${this.data[id].img}" class="img-fluid rounded mb-half mb-sm-0"></div>
            </div>
            <div class="col-xs-12 col-sm-6 order-sm-1">
                <p class="lead">Modelo: <span id="modelo">${this.data[id].modelo}</span></p>
                <h2 id="titulo">${this.data[id].titulo}</h2>
                <p id="texto">${this.data[id].descripcion}</p>
                <p class="small" id="uso">${this.data[id].uso}</p>
                <a id="ficha" href="${this.data[id].ficha}" download class="btn btn-primary">FICHA DE PRODUCTO</a>
            </div>`;
            this.selectedItem.innerHTML = "";
            this.selectedItem.appendChild(this.createFromTag("div", ["row"], template));
            TweenMax.set(this.selectedItem, {height: "auto"});
            TweenMax.staggerFrom(this.selectedItem.querySelectorAll("h2, p.lead, p, a"), 0.2, {x:-5, opacity:0}, 0.1); 
            TweenMax.fromTo(this.selectedItem, 0.5, {y:-10, opacity:0}, {y:0, opacity:1})
        }.bind(this)})
    }

    //chunk the array
    chunk(arr, chunkSize) {
        if (chunkSize <= 0) throw "Invalid chunk size";
        var R = [];
        for (var i=0,len=arr.length; i<len; i+=chunkSize)
            R.push(arr.slice(i,i+chunkSize));
        return R;
    }

    createFromTag(tag, classes, content = null){
        let elem = document.createElement(tag);
        classes.forEach(classToAdd => {
            elem.classList.add(classToAdd)
        });
        if(content) elem.innerHTML = content;
        return elem;
    }
}
export default Productos;